import axios from 'axios'

export const UserService = {
    deleteUserAccount: () => {
        return new Promise(
            function (resolve, reject) {
                axios.delete('/user')
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
    }

}



// WEBPACK FOOTER //
// ./src/services/user-service.js